import { createBrowserHistory } from 'history';

const history = createBrowserHistory();
history.listen(() => {});
export default history;
